var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallcheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.411 5.77919C15.6711 6.00619 15.6978 6.40102 15.4708 6.66104L8.92319 14.161C8.8045 14.297 8.63284 14.375 8.45237 14.375C8.2719 14.375 8.10023 14.297 7.98155 14.161L5.3625 11.161C5.13549 10.901 5.16226 10.5062 5.42229 10.2792C5.68231 10.0522 6.07714 10.0789 6.30414 10.339L8.45237 12.7997L14.5292 5.83897C14.7562 5.57894 15.151 5.55218 15.411 5.77919Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallcheckIcon);
export default __webpack_public_path__ + "static/media/smallcheckIcon.a21c83bf9853662f6a9057c75d46809d.svg";
export { ForwardRef as ReactComponent };